module.exports = __webpack_public_path__ + "img/iomico-map-pin.5dd67f4a.png";